<template>
<div>
    <div class="info">
        <ResultsPractitionerInfoLocation :result="result" :rank="rank"/>
        <ResultsPractitionerInfoSpecialty :result="result" />
        <ResultsPractitionerInfoGender :result="result" />
        <ResultsPractitionerInfoSchedulingPatients :result="result"/>
        <ResultsBaseCostRating :result="result" />
        <ResultsBaseQualityRating :result="result" />
        <ResultsBaseLearnMoreLink :result="result" :rank="rank" />
        <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" ></hp5-spacing-vertical>
        <div class="bottom-panel">
            <ResultsBasePhoneNumber :phoneNumber="phoneNumber" :callNumber="callNumber" :rank="rank"/>
            <ResultsPractitionerCostEstimateLink :result="result" :rank="rank" />
            <ResultsBaseMapToggleButton v-on:toggle="onToggle" :rank="rank"/>
        </div>
    </div>
    <div class="map-container">
        <ResultsPractitionerMap class="map" :practitioner="result" :toggle="toggle" />
    </div>
</div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const toggle =ref(false)
    const callNumber = computed(() => props.result.locationPhoneNumber ? props.result.locationPhoneNumber.parenthesisStyleString.replaceAll(' ', '-') : null )
    const phoneNumber = computed(() => props.result.locationPhoneNumber )

    const onToggle = (event) => toggle.value = !toggle.value

</script>

<style scoped lang="scss">
@use '../../../../assets/scss/breakpoints' as *;


.bottom-panel {
  display: flex;
  align-items: center;
  .toggle {
    align-self: center;
  }
}

.info {
    margin-bottom: var(--spacing-md);
}

.map {
    margin-top: -18px;
    margin-left: -120px;
    margin-right: -18px;
    margin-bottom: -22px;
}

</style>